export default "__VITE_ASSET__BNfjPUhK__"